import constants from '../constants';
import { elHasClass } from '../utils';

export default (dc, config = {}) => {
    const defaultType = dc.getType('default');
    const defaultModel = defaultType.model;
    const { prevName, containerSelector } = constants;
    const classId = config.classPrev;
    const type = prevName;

    dc.addType(type, {
        model: defaultModel.extend(
            {
                init() {
                    this.set({
                        name: 'Nav Previous',
                        copyable: 0,
                        selectable: false,
                        draggable: containerSelector,
                        ...config.prevProps,
                    });

                    if (
                        this.get('classes').pluck('name').indexOf(classId) < 0
                    ) {
                        this.addClass(classId);
                    }
                },
            },
            {
                isComponent(el) {
                    if (elHasClass(el, classId)) {
                        return { type };
                    }
                },
            }
        ),

        view: defaultType.view,
    });
};
